import { render, staticRenderFns } from "./filterSearch.vue?vue&type=template&id=6cbc906b&scoped=true"
import script from "./filterSearch.vue?vue&type=script&lang=js"
export * from "./filterSearch.vue?vue&type=script&lang=js"
import style0 from "./filterSearch.vue?vue&type=style&index=0&id=6cbc906b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc906b",
  null
  
)

export default component.exports